import React, { FC } from 'react'
interface dataTypes {
    register: any;
    errors: any;
    handleChange: (value: any) => void;
    values:any;
}
const NextOfKin: FC<dataTypes> = ({ register, errors, handleChange, values }) => {
//   console.log('NextOfKin', values)
  return (
        <div>

            <div className="row">
                <div className='col-lg-4 col-md-12 col-sm-12'>
                    <label>Full Name <span className="text-danger">*</span></label>
                    <input type={'text'} className='form-control' {...register('nextOfKinName', { required: 'Please fill the field' })} onChange={handleChange} />
                {errors.nextOfKinName && <span className="text-danger">{ errors.nextOfKinName.message }</span>}
                </div>
                <div className='col-lg-4 col-md-12 col-sm-12'>
                    <label>Phone <span className="text-danger">*</span></label>
                    <input type={'text'} className='form-control' {...register('nextOfKinPhone', { required: 'Please fill the field' })} onChange={handleChange}/>
                {errors.nextOfKinPhone && <span className='text-danger'>{ errors.nextOfKinPhone.message }</span>}
                </div>
                <div className='col-lg-4 col-md-12 col-sm-12'>
                    <label>Email <span className="text-danger">*</span></label>
                    <input type={'email'} className='form-control' {...register('nextOfKinEmail', { required: 'Please fill the field' })} onChange={handleChange}/>
                {errors.nextOfKinEmail && <span className='text-danger'>{ errors.nextOfKinEmail.message}</span>}
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-4 col-md-12 col-sm-12'>
                    <label>Next Of Kin Gender <span className="text-danger">*</span></label>

                    <select id="" className="form-control" {...register('nextOfKinGender', { required: 'Please Insert Next Of King Gender' })} onChange={handleChange} >
                        {values.nextOfKinGender === 'male' ? <option>Male</option> : <option>Female</option>}
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>

                    {errors.nextOfKinGender && <span className='text-danger'>{errors.nextOfKinGender.message}</span>}
                </div>
                <div className='col-lg-4 col-md-12 col-sm-12'>
                    <label>Relationship <span className="text-danger">*</span></label>
                    <input type={'text'} className='form-control' {...register('nextOfKinRelationship', { required: 'Please fill the field' })} onChange={handleChange}/>
                    {errors.nextOfKinRelationship && <span className='text-danger'>{errors.nextOfKinRelationship.message}</span>}
                </div>
            </div>

        </div>
  )
}

export default NextOfKin
